import React, { createContext, useContext, useState, useCallback } from 'react';

interface ActiveChatContextType {
  activeChatId: string | null;
  setActiveChatId: (chatId: string | null) => void;
}

const ActiveChatContext = createContext<ActiveChatContextType | undefined>(undefined);

export const ActiveChatProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activeChatId, setActiveChatIdState] = useState<string | null>(null);

  const setActiveChatId = useCallback((chatId: string | null) => {
    setActiveChatIdState(chatId);
  }, []);

  return (
    <ActiveChatContext.Provider value={{ activeChatId, setActiveChatId }}>
      {children}
    </ActiveChatContext.Provider>
  );
};

export const useActiveChat = (): ActiveChatContextType => {
  const context = useContext(ActiveChatContext);
  if (!context) {
    throw new Error('useActiveChat must be used within ActiveChatProvider');
  }
  return context;
};
